import { BridgeActionEnum } from "@/types/webview";
import { postWebviewMessage } from "./postWebviewMessage";

export const getNotificationsStatus = () => {
  postWebviewMessage({
    action: BridgeActionEnum.GetNotificationsStatus,
  });
};
